module.exports = __webpack_public_path__ + "img/case_moneymonk_portrait.cbe61b8f.jpg";